import { Cms } from '@typings';
import cx from 'classnames';

import styles from './section.module.scss';

export const getSectionClassnames = (visibleFor: Cms.SectionVisibility) => {
  const { screen, isHidden } = visibleFor;

  return cx({
    [styles.desktopHidden]: !screen.includes('desktop'),
    [styles.mobileHidden]: !screen.includes('mobile'),
    [styles.tabletHidden]: !screen.includes('tablet'),
    [styles.muted]: isHidden,
  });
};
